import axios from 'axios';
import { Token } from './token';

const getConfig = async () => {
    const token = sessionStorage.getItem("tokenBearer");
    if (!token || token === "false") {
        const responseToken = await Token();
        if(responseToken.status === 200){
        token = responseToken.data.access_token;
        sessionStorage.setItem("tokenBearer", token);
        }else{
          throw new Error("Token no disponible en sessionStorage");
        }
    }
    return {
        headers: { 
            Authorization: `Bearer ${token}`,
            'X-OrigenId': '9',
            'X-ExodusDev': '0'
        }
    };
};

/**
 * Metodo para obtener información acerca de producto
 * @param {idProducto} getProductosDescripciones 
 * @returns object con data de un producto
 */
export const getProductosDescripciones = async (idProducto) => {
    const config = await getConfig();
    return await axios.post(process.env.REACT_APP_DESCRIPCIONPRODUCTO,idProducto, config)
    .catch(function (error) {
        if (error.response) {
            
            return false;
        }
    });
}
/**
 * Metodo para obtener información acerca de producto
 * @param {Producto} obtenerInfoProductoEspecial 
 * @returns object con data de un producto
 */
export const obtenerInfoProductoEspecial = async (pedidoId,sucursalId) => {
  try {
    const config = await getConfig();
    const body = {
      pedidoId,
      sucursalId
    }
    const response = await axios.post(process.env.REACT_APP_DESCRIPCIONPRODUCTO_ESPECIAL, body, { ...config, headers: { ...(config.headers || {}), 'Content-Type': 'application/json' } });
    return response?.data?.data;
  } catch (error) {
    console.error(`Error al obtener info del pedido ${pedidoId}:`, error);
  }
};

export const GetIdsProductsByFamily = async(family) => {
  try{
    const config = await getConfig();
    const response =  await axios.post(process.env.REACT_APP_IDS_FAMILIAS,[family],config)
    return response?.data?.data;
  }catch(error){
    console.error(`Error al obtener los productos de la familia ${family}:`, error);
  }
}

